<template>
    <v-layout row wrap class="auth-wrapper" >

        <v-flex lg2 md2 xs4 offset-xs4 offset-lg5 offset-md5 class="pa-md-100 pa-lg-100 pa-xs-20  text-center" >
<br>
            <v-img 
          
            src="https://firebasestorage.googleapis.com/v0/b/fattoura-86f56.appspot.com/o/fattoura_logo_blue.png?alt=media&token=f3c5f0fc-bad7-4566-955e-1519ec7d654c" 
            class="img-responsive"
                 @click.prevent="() => $router.push({name: 'app.login'})"></v-img>
              
        </v-flex>
        <v-flex lg4 md4 offset-lg4 offset-md4>
           <div class="auth-box" style="">
               <slot></slot>
           </div>
        </v-flex>
    </v-layout>
</template>
<script>

    export default {
    name: 'AuthLayout' ,
    components: {	},
    data() {
        return {
            
        };
    },
    methods: {
            
    }
    }
</script>

<style scoped>
   .auth-wrapper {
        /* Center and scale the image nicely */
        background: url("/images/login-bg.png") no-repeat center;
        background-size: cover;
    }

    .auth-box {
        padding: 20px;
        border-radius: 10px;
    }
</style>